import React from 'react';
import SecondaryTitle from "../../../Components/SecondaryTitle";
import FormInput from "../../../Components/Forms/FormInput";
import {ISA_TYPES, SE_BE_TERMS_AND_CONDITIONS, SE_PRIVACY_POLICY, TITLE_OPTIONS} from "../../../constants";
import Error from "../../../Components/Forms/Error";
import Checkbox from "../../../Components/Forms/Inputs/Checkbox";

const Details = (props) => {
    const {
        data = {
            'subscriptions_belong_to_me':        0,
            'over_16_years':                     0,
            'limit_isa_contributions':           0,
            'no_dual_cash_isa_subscriptions':    0,
            'uk_tax_resident':                   0,
            'accept_terms':                      0,
            'seg_manage_assets':                 0,
            'seg_claim_tax_relief':              0,
        },
        errors      = null,
        onChange    = (field, value) => {},
        disabled    = false
    } = props;

    return (
        <React.Fragment>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'subscriptions_belong_to_me'}
                    label={('All subscriptions made, and to be made, belong to me;')}
                    checked={data.subscriptions_belong_to_me === true || data.subscriptions_belong_to_me === 'true' || data.subscriptions_belong_to_me === 1 || data.subscriptions_belong_to_me === '1'}
                    onChange={(value) => onChange('subscriptions_belong_to_me', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.subscriptions_belong_to_me ? errors.subscriptions_belong_to_me : null} />
            </div>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'over_16_years'}
                    label={('I am 16 years of age or over;')}
                    checked={data.over_16_years === true || data.over_16_years === 'true' || data.over_16_years === 1 || data.over_16_years === '1'}
                    onChange={(value) => onChange('over_16_years', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.over_16_years ? errors.over_16_years : null} />
            </div>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'limit_isa_contributions'}
                    label={('I have not subscribed/made payments, and will not subscribe/make payments, more than the overall subscription/payment limit in total to a cash ISA, a stocks and shares ISA, an innovative finance ISA, and a Lifetime ISA in the same tax year;')}
                    checked={data.limit_isa_contributions === true || data.limit_isa_contributions === 'true' || data.limit_isa_contributions === 1 || data.limit_isa_contributions === '1'}
                    onChange={(value) => onChange('limit_isa_contributions', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.limit_isa_contributions ? errors.limit_isa_contributions : null} />
            </div>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'no_dual_cash_isa_subscriptions'}
                    label={('I have not subscribed and will not subscribe to another cash ISA in the same tax year that I subscribe to this cash ISA;')}
                    checked={data.no_dual_cash_isa_subscriptions === true || data.no_dual_cash_isa_subscriptions === 'true' || data.no_dual_cash_isa_subscriptions === 1 || data.no_dual_cash_isa_subscriptions === '1'}
                    onChange={(value) => onChange('no_dual_cash_isa_subscriptions', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.no_dual_cash_isa_subscriptions ? errors.no_dual_cash_isa_subscriptions : null} />
            </div>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'uk_tax_resident'}
                    label={('I am resident in the United Kingdom for tax purposes or, if not so resident, either perform duties which, by virtue of Section 28 of Income Tax (Earnings & Pensions) Act 2003 (Crown employees serving overseas), are treated as being performed in the United Kingdom, or I am married to, or in a civil partnership with, a person who performs such duties. I will inform [ISA manager\'s name] if I cease to be so resident or to perform such duties or be married to, or in a civil partnership with, a person who performs such duties;')}
                    checked={data.uk_tax_resident === true || data.uk_tax_resident === 'true' || data.uk_tax_resident === 1 || data.uk_tax_resident === '1'}
                    onChange={(value) => onChange('uk_tax_resident', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.uk_tax_resident ? errors.uk_tax_resident : null} />
            </div>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'accept_terms'}
                    label={('I agree to the ISA terms and conditions.')}
                    checked={data.accept_terms === true || data.accept_terms === 'true' || data.accept_terms === 1 || data.accept_terms === '1'}
                    onChange={(value) => onChange('accept_terms', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.accept_terms ? errors.accept_terms : null} />
            </div>

            <SecondaryTitle>I authorise Stubben Edge (Risk) Ltd:</SecondaryTitle>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'seg_manage_assets'}
                    label={('To hold my cash subscription, ISA investments, interest, dividends and any other rights or proceeds in respect of those investments and any other cash;')}
                    checked={data.seg_manage_assets === true || data.seg_manage_assets === 'true' || data.seg_manage_assets === 1 || data.seg_manage_assets === '1'}
                    onChange={(value) => onChange('seg_manage_assets', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.seg_manage_assets ? errors.seg_manage_assets : null} />
            </div>
            <div className={"form-input-container"}>
                <Checkbox
                    name={'seg_claim_tax_relief'}
                    label={('To make on my behalf any claims to relief from tax in respect of ISA investments.')}
                    checked={data.seg_claim_tax_relief === true || data.seg_claim_tax_relief === 'true' || data.seg_claim_tax_relief === 1 || data.seg_claim_tax_relief === '1'}
                    onChange={(value) => onChange('seg_claim_tax_relief', value === true ? 1 : 0)}
                    disabled={disabled}
                />
                <Error error={!!errors && !!errors.seg_claim_tax_relief ? errors.seg_claim_tax_relief : null} />
            </div>
        </React.Fragment>
    );
}

export default Details;
